import { useState } from 'react';

export type DataDel<DelParams extends unknown[]> = (...args: DelParams) => Promise<void>;

type UseDelRes<DelParams extends unknown[]> = {
	loading: boolean;
	del: DataDel<DelParams>;
};

const useDataDel = <DelParams extends unknown[] = [string]>({ api }: { api: DataDel<DelParams> }): UseDelRes<DelParams> => {
	const [loading, setLoading] = useState<boolean>(false);

	const del: DataDel<DelParams> = (...args) => {
		setLoading(true);
		return new Promise<void>((resolve, reject) => {
			api(...args)
				.then((res) => resolve(res))
				.catch((error) => reject(error))
				.finally(() => setLoading(false));
		});
	};

	return { loading, del };
};

export default useDataDel;
